import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  Zoom,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

interface DownloadAppDialogProps {
  open: boolean;
  onClose: () => void;
}

const DownloadAppDialog: React.FC<DownloadAppDialogProps> = ({ open, onClose }) => {
  const handleDownloadClick = () => {
    const downloadUrl =
      'https://play.google.com/store/apps/details?id=com.darukaa.ritva&pcampaignid=web_share';
    window.open(downloadUrl, '_blank');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Zoom}
      aria-labelledby="download-app-dialog-title"
      maxWidth="xs"
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: 4,
          p: 0,
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          overflow: 'hidden',
        },
      }}
    >
      <Box 
        sx={{ 
          height: '140px', 
          background: 'linear-gradient(135deg, #45987A 0%, #2E4636 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          color: '#fff',
        }}
      >
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: 'rgba(255, 255, 255, 0.7)',
            '&:hover': {
              color: '#fff',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        <RocketLaunchIcon sx={{ fontSize: 48, mb: 1, opacity: 0.9 }} />
        <Typography variant="h5" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1.5 }}>
          New Arrival!
        </Typography>
      </Box>

      <DialogTitle id="download-app-dialog-title" sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#151E15', fontSize: '1.75rem' }}>
          Take a look at our new app!
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pb: 3, textAlign: 'center', px: 4 }}>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: '#666', fontSize: '1.1rem', lineHeight: 1.6 }}
        >
          Nature at Your Fingertips. <br />
          Experience seamless biodiversity monitoring and environmental insights anywhere, anytime.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 5, px: 4 }}>
        <Button
          onClick={handleDownloadClick}
          variant="contained"
          fullWidth
          size="large"
          startIcon={<InstallMobileIcon />}
          sx={{
            py: 2,
            borderRadius: 3,
            backgroundColor: '#45987A',
            color: '#fff',
            fontWeight: 800,
            fontSize: '1.1rem',
            textTransform: 'none',
            boxShadow: '0 8px 20px rgba(69, 152, 122, 0.3)',
            '&:hover': {
              backgroundColor: '#387a62',
              boxShadow: '0 12px 25px rgba(69, 152, 122, 0.4)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }}
        >
          Download our new app
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadAppDialog;
